var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0985159873962402, 0, 0, 1.107699990272522, -17.048433303833008, -54.58576965332031)",
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.446,
    y: 71.767,
    width: 158.956,
    height: 152.432,
    style: {
      fill: "currentColor",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(51, 100, 175)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.489,
    y: 181.495,
    width: 65.243,
    height: 24.911,
    style: {
      strokeMiterlimit: 8.45,
      strokeWidth: 7,
      strokeLinejoin: "round",
      fill: "currentColor",
      stroke: "rgb(51, 100, 175)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      strokeWidth: 11,
      fill: "rgb(73, 78, 250)",
      stroke: "rgb(51, 100, 175)"
    },
    x1: 167.26,
    y1: 105.575,
    x2: 329.182,
    y2: 106.169
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0985159873962402, 0, 0, 1.107699990272522, 66.35014343261719, 133.31590270996094)",
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.446,
    y: 71.767,
    width: 158.956,
    height: 152.432,
    style: {
      fill: "currentColor",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(51, 100, 175)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.489,
    y: 181.495,
    width: 65.243,
    height: 24.911,
    style: {
      strokeMiterlimit: 8.45,
      strokeWidth: 7,
      strokeLinejoin: "round",
      fill: "currentColor",
      stroke: "rgb(51, 100, 175)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      strokeWidth: 11,
      fill: "rgb(73, 78, 250)",
      stroke: "rgb(51, 100, 175)"
    },
    x1: 167.26,
    y1: 105.575,
    x2: 329.182,
    y2: 106.169
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0985159873962402, 0, 0, 1.107699990272522, -127.16098022460938, 133.3155975341797)",
    style: {}
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.446,
    y: 71.767,
    width: 158.956,
    height: 152.432,
    style: {
      fill: "currentColor",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(51, 100, 175)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.489,
    y: 181.495,
    width: 65.243,
    height: 24.911,
    style: {
      strokeMiterlimit: 8.45,
      strokeWidth: 7,
      strokeLinejoin: "round",
      fill: "currentColor",
      stroke: "rgb(51, 100, 175)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      strokeWidth: 11,
      fill: "rgb(73, 78, 250)",
      stroke: "rgb(51, 100, 175)"
    },
    x1: 167.26,
    y1: 105.575,
    x2: 329.182,
    y2: 106.169
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.438,
    y: 426.337,
    width: 38.441,
    height: 38.106,
    style: {
      strokeWidth: 7,
      strokeLinejoin: "round",
      fill: "currentColor",
      stroke: "rgb(51, 100, 175)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.238,
    y: 423.051,
    width: 38.441,
    height: 38.106,
    style: {
      strokeWidth: 7,
      strokeLinejoin: "round",
      fill: "currentColor",
      stroke: "rgb(51, 100, 175)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.553,
    y: 423.051,
    width: 38.441,
    height: 38.106,
    style: {
      strokeWidth: 7,
      strokeLinejoin: "round",
      fill: "currentColor",
      stroke: "rgb(51, 100, 175)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.71,
    y: 393.487,
    width: 482.8,
    height: 35.477,
    style: {
      strokeWidth: 7,
      strokeLinejoin: "round",
      fill: "currentColor",
      stroke: "rgb(51, 100, 175)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatel);
export default __webpack_public_path__ + "static/media/matel.e51eca45a7878082c93066b66d6c0fa4.svg";
export { ForwardRef as ReactComponent };